import { withInstall } from "../utils/index.mjs";
import _IndexAnchor from "./IndexAnchor.mjs";
const IndexAnchor = withInstall(_IndexAnchor);
var stdin_default = IndexAnchor;
import { indexAnchorProps } from "./IndexAnchor.mjs";
export {
  IndexAnchor,
  stdin_default as default,
  indexAnchorProps
};
